import axios from 'packs/modules/axios'

window.addEventListener('DOMContentLoaded', () => {
  const BookmarkButtons = document.querySelectorAll('.js-hospital_program_bookmark');
  const ApiVersion = 'v1'
  const BookmarkOn = 'on'
  const BookmarkOff = 'off'

  BookmarkButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      const hospital_program_id = e.currentTarget.dataset.hospital_program_id
      const hospital_program_buttons = document.querySelectorAll(`[data-hospital_program_id="` + hospital_program_id + `"]`)
      if (e.currentTarget.classList.contains(BookmarkOff)) {
        const result = await postBookmark(hospital_program_id)
        if (result.status == 'ok') {
          hospital_program_buttons.forEach(element => {
            // IE11 doesn't support classList.replace
            // element.classList.replace(BookmarkOff, BookmarkOn);
            element.classList.remove(BookmarkOff)
            element.classList.add(BookmarkOn)
          })
        }
      } else {
        const result = await deleteBookmark(hospital_program_id)
        if (result.status == 'ok') {
          hospital_program_buttons.forEach(element => {
            // IE11 doesn't support classList.replace
            // element.classList.replace(BookmarkOn, BookmarkOff);
            element.classList.remove(BookmarkOn)
            element.classList.add(BookmarkOff)
          })
        }
      }
    })
  })

  const postBookmark = async (hospital_program_id) => {
    try {
      const { data } = await axios.post(
        `/api/${ApiVersion}/program_bookmark`,
        {
          hospital_program_id: hospital_program_id,
          headers: {
            accept: 'application/json'
          }
        }
      )
      return data
    } catch (e) {
      if (e.response && e.response.status === 404) {
        return []
      }
      throw e
    }
  }

  const deleteBookmark = async (hospital_program_id) => {
    try {
      const { data } = await axios.delete(
        `/api/${ApiVersion}/program_bookmark`,
        {
          data: { hospital_program_id: hospital_program_id },
          headers: {
            accept: 'application/json'
          }
        }
      )
      return data
    } catch (e) {
      if (e.response && e.response.status === 404) {
        return []
      }
      throw e
    }
  }
})
